import { SxProps, Theme } from '@mui/material/styles';

const AI_CURSOR_SVG = btoa(
  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">'
  + '<defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1">'
  + '<stop offset="0%" stop-color="#4F55E7"/>'
  + '<stop offset="40%" stop-color="#6E46EC"/>'
  + '<stop offset="80%" stop-color="#D213DF"/>'
  + '<stop offset="100%" stop-color="#00AEC6"/>'
  + '</linearGradient></defs>'
  + '<path d="M12 1l2.5 7.5L22 12l-7.5 2.5L12 22l-2.5-7.5L2 12l7.5-2.5z" fill="url(#g)"/>'
  + '</svg>'
);

export const AI_CURSOR = `url("data:image/svg+xml;base64,${AI_CURSOR_SVG}") 12 12, pointer`;

export const getAIFindingBoxSx = (ctrlHeld: boolean): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  width: 'auto',
  height: '100%',
  overflow: 'hidden',
  '& > *': {
    width: '100%',
    textAlign: 'inherit',
  },
  ...(ctrlHeld && {
    cursor: AI_CURSOR,
    '& *': { cursor: `${AI_CURSOR} !important` },
  }),
});
